<template>
    <div>

    </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            user: {}
        }
    },
    methods: {
        getUser() {
            axios.get('/me')
                .then(response => {
                    this.$store.dispatch('user/initState', response.data.user);
                    // this.$store.dispatch('user/updateUser', response.data.user);
                    // this.$store.dispatch('user/updateProfile', this.getUser.roles[0]);
                    // const permissions = this.getProfile.perms.map(permission => permission.name);
                    // this.$store.dispatch('user/updatePermissions', permissions);
                    // this.user = response.data;
                })
                .catch(error => {
                    window.href = '/login';
                    console.error(error);
                });
        }
    },
    computed:{
        ...mapGetters(['user/getUser', 'user/getProfile', 'user/getPermissions'])
    },
    mounted() {
        this.getUser();
    }
}

</script>

<style></style>


// WEBPACK FOOTER //
// resources/assets/js/components/util/UserHome.vue